import { urls } from "configs/serviceConfig";

export async function sendForgottenPasswordEmail(email: {}) {
  let body =  {
    ...email,
    callingApplication: "theDugout"
  }
  await fetch(
    `${urls.profileService}/password-reset/send`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(body),
    }
  );
}

export async function resendForgottenPasswordEmail(token: string) {
  let body =  {
    token,
    callingApplication: "theDugout"
  }
  await fetch(
    `${urls.profileService}/password-reset/resend`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(body),
    }
  );
}